import { Component, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';

import { AppState } from '../../shared/models';
import * as actions from '../../store/actions';
import {
  selectSelectedRole,
  selectApplications,
  selectRoles,
  selectSelectedApplicationGroups,
  selectUnselectedApplicationGroups,
  selectApplicationsForGroup,
  selectExternalEntityType,
} from '../../store/selectors';

@Component({
  selector: 'app-authorizations',
  templateUrl: './authorizations.component.html',
  standalone: false,
})
export class AuthorizationsComponent {
  private readonly store = inject<Store<AppState>>(Store);

  applications = this.store.pipe(select(selectApplications));
  selectedApplicationGroups = this.store.pipe(select(selectSelectedApplicationGroups));
  unselectedApplicationGroups = this.store.pipe(select(selectUnselectedApplicationGroups));
  roles = this.store.pipe(select(selectRoles));
  profileType$: Observable<string> = this.store.select(selectExternalEntityType);

  openApplicationGroupDialog(): void {
    this.store.dispatch(actions.selectApplicationGroups());
  }

  getSelectedRole(applicationKey: string) {
    return this.store.pipe(select(selectSelectedRole, applicationKey));
  }

  getApplications(groupId: number) {
    return this.store.pipe(select(selectApplicationsForGroup(groupId)));
  }

  deleteGroupUseraccess(groupId: number) {
    this.store.dispatch(actions.deleteGroupUseraccess({ groupId }));
  }

  setUseraccess(applicationKey: string, roleKey: string) {
    this.store.dispatch(actions.setUseraccess({ applicationKey, roleKey }));
  }
}
